<template>

    <cms-modal :title="modalTitle" @close="dismiss">

        <cms-form submit-button="Afsluiten" :submitting="submitting" @submit="submit" v-spinner="loading">

            <cms-form-radio bool="true" v-model="frequence" name="resolveActionFrequence" title="Meet-/zendfrequentie gecontroleerd"
                            v-validate="'required|in:1'" data-vv-as="Meet-/zendfrequentie gecontroleerd" :error="error('resolveActionFrequence')"></cms-form-radio>

        </cms-form>

    </cms-modal>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'
    import moment from 'moment'

    import ActionMutations from 'app/mutations/ActionMutations'
    import ActionState from 'app/enums/ActionState'

    @Component({

        name: 'resolve-action-modal',
        props: ['action']
    })
    export default class extends Vue
    {
        data(){

            return {

                loading: 0,
                submitted: false,
                submitting: false,

                frequence: null
            }
        }

        get modalTitle(){

            return 'Actie afsluiten';
        }

        cancel(){

            this.dismiss();
        }

        error(field){

            return this.submitted ? this.errors.first(field) : null;
        }

        submit(){

            this.submitted = true;

            this.$validator.validateAll().then(success => {

                if (!success) {

                    this.$toast.error('Er zijn één of meerdere fouten');
                    return;
                }

                this.resolveAction();
            });
        }

        resolveAction(){

            this.$logger.info('Resolving action');

            this.submitting = true;

            ActionMutations.update({ id: this.action.id, state: ActionState.CLOSED }).then(() => {

                this.$emit('dismiss', true);

            }).catch(error => {

                this.$logger.error('Error resolving action', error);
                this.$toast.error('Kon de actie niet afsluiten');

                this.submitting = false;
            })
        }

        dismiss(){

            this.$emit('dismiss');
        }
    }

</script>
